export enum ClassificationBackfillTarget {
  LlmThreads = "llm_threads",
  SupportTickets = "support_tickets",
}
